import { QuestionGroupType } from '@exam-management/graphql';

export function getQuestionType(questionGroupType: QuestionGroupType | undefined) {
  switch (questionGroupType) {
    case QuestionGroupType.ItemSet:
      return 'item-set';
    case QuestionGroupType.Single:
    case QuestionGroupType.LotOfQuestion:
    default:
      return 'single';
  }
}
